import { type ReadonlyURLSearchParams } from "next/navigation";

/**
 * Constructs a URL string by combining a pathname with query parameters.
 *
 * @param pathname - The base path of the URL (e.g., "/products").
 * @param params - An instance of URLSearchParams or ReadonlyURLSearchParams containing query parameters.
 * @returns The full URL string with query parameters appended if present.
 *
 * @example
 * ```typescript
 * createUrl("/products", new URLSearchParams({ category: "books", sort: "asc" }));
 * // Returns: "/products?category=books&sort=asc"
 * ```
 *
 * @example
 * ```typescript
 * createUrl("/about", new URLSearchParams());
 * // Returns: "/about"
 * ```
 */
export const createUrl = (
  pathname: string,
  params: URLSearchParams | ReadonlyURLSearchParams,
) => {
  const paramsString = params.toString();
  const queryString = `${paramsString.length ? "?" : ""}${paramsString}`;

  return `${pathname}${queryString}`;
};
